import React from 'react';

import { Heading, Container, Row, Col } from 'soluble-design-system-base';

import style from './style.module.scss';

import colorStyle from '../../scss/color.module.scss';

export default function DemoTextSection({ demoTextNode, colorScheme }) {
    return (
        <section className={colorStyle[`bg--${colorScheme}`]}>
            <Container pt={{ xs: 10, lg: 12 }} pb={{ xs: 10, lg: 12 }}>
                <Row>
                    <Col col={{ lg: 8 }} className={style.demoTextContainer}>
                        <Heading tag="div" className={style.demoText}>
                            {demoTextNode.contentWithoutWrapperUnderline}
                        </Heading>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
